import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <img src={process.env.PUBLIC_URL + '/logo.svg'} alt="Oscilabs" />
          <span className="footer-copy">&copy; 2026 Oscilabs. All rights reserved.</span>
        </div>
        <div className="footer-tagline">Operate With Certainty</div>
      </div>
    </footer>
  );
}
